const AdminAuthenticator = ['UserService', '$q', '$state', (UserService, $q, $state) => {
  const deferred = $q.defer();
  UserService.me().then((result) => {
    if (result && result.data.user_type === 'admin') {
      deferred.resolve(result.data);
    } else {
      $state.go('home', null, { location: 'replace' });
    }
  }, () => {
    $state.go('home', null, { location: 'replace' });
  });
  return deferred.promise;
}];

export default AdminAuthenticator;
